import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import useSeo from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";
import FocusHero from "@/pages/home/components/FocusHero";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestSection from "@/pages/home/components/LatestSection";
import TimelineSpotlight from "@/pages/home/components/TimelineSpotlight";
import FaqPreview from "@/pages/home/components/FaqPreview";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Home() {
  const featured = articles.find((a) => a.featured) ?? articles[0];
  const sideLatest = articles.filter((a) => a.id !== featured.id).slice(0, 5);
  const latestGrid = articles.filter((a) => a.id !== featured.id).slice(0, 6);
  const hot = [...articles].sort((a, b) => b.views - a.views).slice(0, 6);
  const spotlight = articles.find((a) => a.id === "livestream-refund-21days") ?? articles[1];

  useSeo({
    title: "17爆料网 - 网络热点爆料聚合与事件时间线整理",
    description:
      "17爆料网围绕公开流传的网络热点事件，按事件整理时间线、公开线索与多方说法，涵盖娱乐爆料、消费维权、职场观察与网络现场，帮助读者看清来龙去脉。",
    keywords: "17爆料网,网络热点,爆料整理,事件时间线,消费维权,热点聚合",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "17爆料网",
        description: siteInfo.intro,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://17baoliao.example.com/topics?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "17爆料网",
        email: siteInfo.email,
        description: siteInfo.intro,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 4).map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.answer },
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <h1 className="w-full px-4 pt-8 font-heading text-xl font-black tracking-tight text-foreground-950 md:px-8 md:text-2xl">
          17爆料网 · {siteInfo.slogan}
        </h1>
        <p className="w-full px-4 pt-3 text-sm leading-relaxed text-foreground-600 md:px-8 md:text-base">
          {siteInfo.intro}
        </p>
        <div className="h-8 md:h-10"></div>
        <FocusHero featured={featured} latest={sideLatest} />
        <CategoryGrid />
        <LatestSection list={latestGrid} hot={hot} />
        <TimelineSpotlight article={spotlight} />
        <FaqPreview />
        <CtaSection />
      </main>
      <SiteFooter />
    </div>
  );
}